const SPA_PATH = 'spa'
const pagesHandledBySPA = ['detail', 'search', 'storefront', 'watchlist', 'downloads', 'mystuff', 'actor', 'person', 'profiles'].join('|')
const whitelistedHosts = ['primevideo.com', 'amazon.(com|co.uk|de|co.jp)', 'localhost'].join('|')
const regionPath = 'region/(na|eu|fe)/'
const classicPath = 'gp/video/'
const personPagePath = 'prime-video/'
const port = ':([0-9]){1,4}'
const path = `(${regionPath})?(${classicPath})?(${personPagePath})?`
const whitelistedAbsolutePathRegEx = new RegExp(`(${whitelistedHosts})(${port})?/(${path})(spa/)?(${pagesHandledBySPA})/`)
const whitelistedRelativePathRegEx = new RegExp(`^/${path}?(spa/)?(${pagesHandledBySPA})/`)
const replaceRegEx = new RegExp(`^https?://[^/]*/${path}`)
const replaceRelativeRegEx = new RegExp(`^/${path}`)


export const pathPrefix = (path: string) => {
  const match = path && path.match(new RegExp(`${regionPath}${classicPath}|${classicPath}|${regionPath}`))
  return '/' + (match && match[0] || '') + SPA_PATH
}

const addBase = (path: string) => (
  path.startsWith('/spa/') ? path : `/${SPA_PATH}${path}`
)

export const convertToSPAPath = (path: string, withBase: boolean = false) => {

  if (!(path && (path.match(whitelistedAbsolutePathRegEx) || path.match(whitelistedRelativePathRegEx)))) {
    return ''
  }

  const p = path.replace(replaceRegEx, '/').replace(replaceRelativeRegEx, '/')
  return withBase ? addBase(p) : p.replace(/spa\//g, '')
}
